import { MutableRefObject, JSX, Fragment } from 'react';
import { Modal } from '@bg-components/Modal';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { PagesModalHeader } from '@bg-components/Modals/components/PagesModalHeader';
import { SettingsIcon } from '@bg-components/Icon';
import { GameSounds } from '@bg-components/Modals/TopSettingsModal/GameSounds';
import { BackgroundMusic } from '@bg-components/Modals/TopSettingsModal/BackgroundMusic';
import { GuiOnlyAnimations } from '@bg-components/Modals/TopSettingsModal/GuiOnlyAnimations';
import { CertifiedRng } from '@bg-components/Modals/TopSettingsModal/CertifiedRng';
import { GameLimits } from '@bg-components/Modals/TopSettingsModal/GameLimits';
import { StudioSounds } from '@bg-components/Modals/TopSettingsModal/StudioSounds';
import { ListSection } from '@bg-components/Modals/TopSettingsModal/List/ListSection';
import { ModalName, IModalProps, t, GameSettings, ISkywardGameId, GameId } from '@bg-shared';
import { CasinoSettings } from './CasinoSettings';
import { VideoSettings } from './VideoSettings';
import classes from './TopSettingsModal.module.scss';

interface IProps extends IModalProps {
    settings?: GameSettings[][];
    openerElementRef?: MutableRefObject<HTMLElement>;
    gameId?: GameId;
}

export const TopSettingsModal = (props: IProps): JSX.Element => {
    const SETTING_MAP: Record<GameSettings, JSX.Element> = {
        [GameSettings.VIDEO]: <VideoSettings />,
        [GameSettings.CASINO]: <CasinoSettings />,
        [GameSettings.GAME_SOUND]: <GameSounds />,
        [GameSettings.MUSIC]: <BackgroundMusic />,
        [GameSettings.ANIMATION]: <GuiOnlyAnimations />,
        [GameSettings.CERTIFICATE]: <CertifiedRng />,
        [GameSettings.LIMITS]: <GameLimits gameId={props.gameId as ISkywardGameId} />,
        [GameSettings.STUDIO_SOUND]: <StudioSounds />,
    };

    return (
        <Modal
            modalName={ModalName.TOP_SETTINGS}
            className={classes.modal}
            animation={fadeAnimation}
            onClose={props.onClose}
            openerElementRef={props.openerElementRef}
        >
            <PagesModalHeader
                title={t.string('settings')}
                icon={SettingsIcon}
                onClose={props.onClose}
            />
            <ModalContent className={classes.content}>
                {props.settings?.map((section, index) => (
                    <ListSection key={index}>
                        {section.map((setting) => (
                            <Fragment key={setting}>{SETTING_MAP[setting]}</Fragment>
                        ))}
                    </ListSection>
                ))}
            </ModalContent>
        </Modal>
    );
};
